import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image } from 'react-native';
import * as RootNavigation from '../../../root.navigation.js';

const width = Dimensions.get('window').width;


const PlusIcon = (props) => (
  <Icon {...props} name='plus-square-outline' />
);
export const RegisterScreen = () => {


  return (

      <Layout style={styles.container} level='2' >
      <SafeAreaView>
      <ScrollView>
      <Layout level='2' style={{flex:1,justifyContent:'space-between', alignItems:'center'}}>
        <Layout level='2' style={{alignItems:'center', marginTop:20}}>

          <Text category='h4' status='primary'>ثبت نام</Text>
          <Text category='p1' appearance='hint' >خدمات پس از فروش نمایندگان</Text>
          <Image
            style={{width:width, height: width/1.43, marginVertical:20}}
            source={require('../../../assets/signup.png')}
          />
        </Layout>
        <Layout level='2' style={{alignItems:'center', marginTop:20, marginHorizontal:30}}>
          <Text category='p1' appearance='hint' style={{textAlign:'center', lineHeight: 22}}>
          لطفا قبل از تکمیل فرم ثبت نام با مرکز نمایندگان شرکت تماس گرفته و از آخرین شرایط و ضوابط نمایندگان و خدمات پس از فروش مطلع شود. تکمیل فرم ثبت نام به منزله پذیرش کلیه قوانین شرکت می‌باشد. پس از ارسال فرم و بررسی توسط کارشناسان با شما تماس گرفته می‌شود.
          </Text>

        </Layout>
        <Button style={{width:width-40,borderRadius:10, marginBottom:25, marginTop:15}} onPress={()=>{RootNavigation.navigate('RegisterForm')}}>ادامه</Button>


      </Layout>
      </ScrollView>
      </SafeAreaView>


      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between',

  },
});
